export default __webpack_public_path__ + "static/media/parte-lateral-certificado.2da9eec9.png";